var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VkdHeader',{attrs:{"barData":_vm.barData},on:{"handleLeft":_vm.handleLeft}})}
var staticRenderFns = []

export { render, staticRenderFns }